import Empty from './empty'

export default Empty


// WEBPACK FOOTER //
// ./src/components/base/empty/index.js